export const getSiblings = e => {
  let siblings = [];

  if (!e.parentNode) {
    return siblings;
  }

  let sibling = e.parentNode.firstChild;

  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== e) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling;
  }
  return siblings;
};

export const dateIsValid = dateToCheck => {
  var dateFrom = '01/01/1900';
  var today = new Date();
  var dateTo = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();

  var d1 = dateFrom.split('/');
  var d2 = dateTo.split('/');
  var c = dateToCheck.split('/');

  var from = new Date(d1[2], parseInt(d1[1]) - 1, d1[0]);
  var to = new Date(d2[2], parseInt(d2[1]) - 1, d2[0]);
  var check = new Date(c[2], parseInt(c[1]) - 1, c[0]);

  if (
    parseInt(c[0]) < 1 ||
    parseInt(c[0]) > 31 ||
    parseInt(c[1]) < 1 ||
    parseInt(c[1]) > 12 ||
    parseInt(c[2]) < 1900 ||
    check < from ||
    check > to
  ) {
    return false;
  }

  return true;
};
